export const UserIdentityProperty = {
  IS_OWNER: 'isOwner',
  IS_AUTHORIZED_SIGNER: 'isAuthorizedSigner',
  IS_UW_MANAGER: 'isUwManager',
};
